import { getDocuments } from '../hooks/local_db/functions';
import { ICommodity } from '../interface/Commodity';
import { observable } from 'mobx';
import { IItemMultiple } from 'welltrax-ui-components/lib/types/Form/Inputs/SelectMultipleField';

export const {
  commodityObjects,
  isCrude,
  refreshCommodity,
  getCommodityById,
  parseCommoditiesForMenu,
  setCommodities
} = (() => {
  const commodityObjects = observable.object({
    data: [],
    get getAsSelectList(): IItemMultiple[] {
      return this.data?.map((el: any) => ({ value: el?.id, label: el.description }));
    }
  } as any);

  function setCommodities(value: ICommodity[]) {
    commodityObjects.data = value || [];
  }

  function isCrude(idCommodity: number): boolean {
    return commodityObjects.data.some((ele: any) => ele?.id === idCommodity && !!ele?.extraColumns?.['IS_CRUDE']);
  }

  function getCommodityById(idCommodity: number): ICommodity | undefined {
    return commodityObjects.data.find((el: any) => idCommodity === el?.id);
  }

  function refreshCommodity() {
    getDocuments('util/commodities', 'Commodity', (commodities: ICommodity[]) => {
      setCommodities(commodities);
    });
  }

  function parseCommoditiesForMenu(commoditiesList: any[]) {
    return commoditiesList.map(item => ({
      label: item.name || item.description,
      value: item.id,
      status: item.isActive || item.status
    }));
  }

  refreshCommodity();

  return {
    refreshCommodity,
    isCrude,
    getCommodityById,
    commodityObjects,
    parseCommoditiesForMenu,
    setCommodities
  };
})();
